export const PROMPT_SUGGESTIONS_OFFSET = 0;
